class QuickViewDrawerCard extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    const close_btn = this.querySelector('[data-close]');
    const open_btn = this.querySelector('.quick-view__summary');
    const product_image = this.parentElement.querySelector('a[data-toggle="modal"]');

    if (product_image && open_btn) {
      product_image.addEventListener('click', (event) => {
        event.preventDefault();
        open_btn.click();
      });
    }

    if (close_btn) {
      close_btn.addEventListener('click', (event) => {
        this.closeMenuDrawer(event);
      });
    }
  }

  // Bloque le scroll à l'ouverture
  openMenuDrawer(event) {
    super.openMenuDrawer?.(event);
    ScrollLock.lock();

    // Réinitialiser l'accordion : fermer tous les tabs sauf le premier
    const resetAccordion = () => {
      const modalContent = this.querySelector('.quick-view__content-scroll');
      if (!modalContent) return;

      const accordionTabs = modalContent.querySelectorAll('accordion-tab');

      accordionTabs.forEach((accordionTab, index) => {
        const details = accordionTab.querySelector('details');
        if (!details) return;

        if (index === 0) {
          // Ouvrir le premier onglet
          details.setAttribute('open', '');
          details.open = true;
          // S'assurer que la classe closed est retirée si le composant AccordionTab est initialisé
          const content = accordionTab.querySelector('.accordion__content');
          if (content) {
            content.classList.remove('closed');
          }
        } else {
          // Fermer tous les autres onglets
          details.removeAttribute('open');
          details.open = false;
          // Utiliser la méthode shrink si disponible
          if (accordionTab.shrink && typeof accordionTab.shrink === 'function') {
            accordionTab.shrink();
          }
          const content = accordionTab.querySelector('.accordion__content');
          if (content) {
            content.classList.add('closed');
          }
        }
      });
    };

    // Réinitialiser le scroll au début de la modal
    const resetScroll = () => {
      const modalContent = this.querySelector('.quick-view__content-scroll');
      if (modalContent) {
        modalContent.scrollTop = 0;
      }
    };

    // Attendre que la modal soit complètement ouverte
    setTimeout(() => {
      requestAnimationFrame(() => {
        resetScroll();
        resetAccordion();
        // Double vérification après un court délai supplémentaire
        setTimeout(() => {
          resetScroll();
          resetAccordion();
        }, 200);
      });
    }, 300);
  }

  // Rétablit le scroll à la fermeture
  closeMenuDrawer(event) {
    // Réinitialiser l'accordion et le scroll à la fermeture pour garantir un état propre à la prochaine ouverture
    const modalContent = this.querySelector('.quick-view__content-scroll');
    if (modalContent) {
      // Réinitialiser le scroll
      modalContent.scrollTop = 0;

      // Réinitialiser l'accordion
      const accordionTabs = modalContent.querySelectorAll('accordion-tab');
      accordionTabs.forEach((accordionTab, index) => {
        const details = accordionTab.querySelector('details');
        if (!details) return;

        if (index === 0) {
          // Garder le premier ouvert pour la prochaine ouverture
          details.setAttribute('open', '');
          details.open = true;
        } else {
          // Fermer tous les autres
          details.removeAttribute('open');
          details.open = false;
        }
      });
    }

    super.closeMenuDrawer?.(event);
    ScrollLock.unlock();
  }
}

customElements.define('quick-view-drawer-card', QuickViewDrawerCard);
